import { atom } from "jotai";
import { DataSource } from "./hooks/useColorizedValue";
import { AccountLabel } from "@/entities/Labeling/Account.model";
import { FinanceLabField } from "@/entities/FinanceLab";
import { Metric } from "@/entities/Finance/Finance.model";

export const enum MetricKey {
    REVENUE = "revenue",
    EBITDA = "ebitda",
    CASH = "cash",
    TOTAL_ASSETS = "totalAssets",
    TOTAL_LIABILITIES = "totalLiabilities",
    NET_INCOME = "netIncome",
    CRM_OPPORTUNITY_ID = "crmOpportunityId",
    CRM_OPPORTUNITY_NAME = "crmOpportunityName",
}

export type DataSourceOverrides = Partial<Record<MetricKey, DataSource>>;

export const dataSourceOverridesAtom = atom<DataSourceOverrides>({});

export const selectedMetricLabelAtom = atom<
    AccountLabel | FinanceLabField | null
>(AccountLabel.REVENUES);

export type SelectedMetricForDrawer = {
    metric: Metric | undefined;
    title: string;
} | null;

export const selectedMetricForDrawerAtom = atom<SelectedMetricForDrawer>(null);

export type SelectedMetricForLineage = {
    metric: Metric | null;
    period: string;
    title: string;
} | null;

export const selectedMetricForLineageAtom =
    atom<SelectedMetricForLineage>(null);

export const showInvestmentCriteriaDrawerAtom = atom<boolean>(false);
